var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI05Ai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5975 11.1682L9.93305 6.20158C9.80776 5.89732 9.66458 5.53041 9.5035 5.10087C9.36032 4.65342 9.23503 4.19703 9.12765 3.73169C9.00236 4.21493 8.86813 4.67132 8.72495 5.10087C8.59967 5.53041 8.46543 5.89732 8.32225 6.20158L6.68461 11.1682H11.5975ZM18.2823 18.0409H15.0071C14.6491 18.0409 14.3538 17.9604 14.1211 17.7993C13.9063 17.6203 13.7542 17.3966 13.6647 17.1281L12.5909 14.0139H5.71813L4.64427 17.1281C4.53688 17.3787 4.36685 17.5935 4.13418 17.7725C3.91941 17.9514 3.63305 18.0409 3.27509 18.0409H-0.000192912L7.00677 1.4207e-05H11.2754L18.2823 18.0409ZM23.9262 18.0409H19.7113V1.4207e-05H23.9262V18.0409Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI05Ai);
export default __webpack_public_path__ + "static/media/I05-AI.80f3ce782b71610558127ea8e86bde1f.svg";
export { ForwardRef as ReactComponent };